import axios from "axios";

const authStore = {
  authData: null,

  token: null,

  setAuth(data) {
    this.authData = data;

    sessionStorage.setItem("authData", JSON.stringify(data));
  },

  setToken(token) {
    this.token = token;

    sessionStorage.setItem("token", token);
  },

  loadSession() {
    const authData = sessionStorage.getItem("authData");

    const token = sessionStorage.getItem("token");

    if (authData) {
      this.authData = JSON.parse(authData);
    }

    if (token) {
      this.token = token;
    }
  },

  async generateToken() {
    try {
      this.loadSession();

      const baseUrl = this.authData?.url;

      const username = this.authData?.username;

      const password = this.authData?.password;

      const params = new URLSearchParams();

      params.append("username", username);
      params.append("password", password);

      const response = await axios.post(
        `${baseUrl}/api/generate_token`,
        params,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      );

      const token = response?.data?.access_token;

      if (token) {
        this.setToken(token);

        return token;
      }

      return null;
    } catch (error) {
      console.log("TOKEN ERROR :", error);

      return null;
    }
  },

  async getAuthHeader() {
    this.loadSession();

    let token = this.token;

    // GENERATE TOKEN IF NOT AVAILABLE
    if (!token) {
      token = await this.generateToken();
    }

    return {
      Authorization: `Bearer ${token}`,
    };
  },

  async refreshToken() {
    const token = await this.generateToken();

    return {
      Authorization: `Bearer ${token}`,
    };
  },

  clearAuth() {
    this.authData = null;

    this.token = null;

    sessionStorage.clear();
  },
};

export default authStore;
